export const RouteGetMerchflowStorePog_storePogId_previousAssortmentCandidates =
  "/merchflow/store/pog/:storePogId/previous-assortment-candidates";

export interface ParamsGetMerchflowStorePog_storePogId_previousAssortmentCandidates {
  search?: string;
}

export interface PreviousAssortmentCandidate {
  id: number;
  source: "OWA" | "JDA";
  label: string;
  delivered_at: string;
}

export interface ResponseGetMerchflowStorePog_storePogId_previousAssortmentCandidates {
  candidates: PreviousAssortmentCandidate[];
}
